import React, { useState } from "react";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import { useNavigate } from 'react-router-dom';
import api from "../../Services/api";
import "./login.css";
import logo from '../../Imagens/logoRoteiro.png';

export const Login = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");

  const navigate = useNavigate();

  const validateForm = () => {
    return email.length > 0 && password.length > 0;
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (!validateForm()) {
      setError("Por favor, preencha todos os campos.");
      return;
    }

    try {
      const token = await getToken();
      localStorage.setItem("token", token);

      const usuario = await buscaUsuario(token);
      if (usuario.data.resultado?.length > 0) {
        localStorage.setItem("Usuario", email);
        navigate("/Home");
      } else {
        setError("Usuário inválido!");
        localStorage.removeItem("token"); // Remove o token inválido
      }
    } catch (err) {
      setError("Erro ao autenticar. Tente novamente.");
      console.error(err);
    }
  };

  const getToken = async () => {
    api.defaults.headers.post = { 'Content-Type': 'application/json' };
    const response = await api.post('/get-token', {
      'user': 'xxtgs627683yshjsb872gd_nix*',
      'pwd': 'kkbecuix_jwedbxiw62734782bxib9823gsdgxxx_',
    });
    return response.data.token;
  };

  const buscaUsuario = async (token) => {
    api.defaults.headers.common = { 'x-access-token': token };
    const response = await api.get(`/getUsuarioLogin/${email}/${password}`);
    return response;
  };

  return (
    <div className="login-container">
      <div className="login-card">
        <div className="login-header">
          <img src={logo} alt="Logo" className="login-logo" />
          <h1 className="titulo-login">Bem-vindo de volta! <span>Faça seu login</span></h1>
        </div>
        <Form onSubmit={handleSubmit}>
          <Form.Group className="groups" size="lg" controlId="email">
            <Form.Control
              autoFocus
              type="text"
              value={email}
              className="campo"
              onChange={(e) => setEmail(e.target.value.toLowerCase())}
              placeholder="Login"
              autoComplete="username"
            />
          </Form.Group>
          <Form.Group className="groups" size="lg" controlId="password">
            <Form.Control
              type="password"
              value={password}
              className="campo"
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Senha"
              autoComplete="password"
            />
          </Form.Group>
          {error && <div className="error">{error}</div>}
          <Button size="md" className="btn_login" type="submit">
            Entrar
          </Button>
        </Form>
        <div style={{ textAlign: 'center', color: '#aaa', fontSize: 'small', marginTop: '10px' }}>
          Precisa de ajuda? <a href="https://wa.me/5535991732995?text=Yuri,%20preciso%20de%20ajuda%20com%20Roteiro%20Seguro." target="_blank" rel="noopener noreferrer">Clique aqui</a>
        </div>
      </div>
    </div>
  );
};